export function handleTypeTransaction(value) {
  value = value.toLowerCase();

  const options = {
    ["deposit"]: "Depósito",
    ["withdraw"]: "Saque",
    ["buy_token"]: "Compra de tokens",
    ["sell_token"]: "Venda de tokens",
    ["profit_distribution"]: "Rentabilização",
  };

  return options[value] || "--";
}

export function normalizeTokenStatus(value) {
  return value?.toUpperCase?.() || "";
}

export function isTokenPaused(value) {
  return normalizeTokenStatus(value) === "PAUSED";
}

export function isTokenFinal(value) {
  return ["FUNDED", "FULLY_FUNDED", "SOLD_OUT"].includes(
    normalizeTokenStatus(value)
  );
}

export function canBuyTokenStatus(value) {
  return normalizeTokenStatus(value) === "FUNDING";
}

export function handleTokenStatus(value) {
  if (!value) return "--";

  value = normalizeTokenStatus(value);

  const options = {
    DRAFT: {
      label: "Rascunho",
      description: "Este projeto ainda não está disponível.",
    },
    PUBLISHED: {
      label: "Anunciado",
      description: "Este projeto será aberto em breve.",
    },
    FUNDING: {
      label: "Disponível",
      description: "Você já pode investir neste projeto.",
    },
    PAUSED: {
      label: "Pausado",
      description: "As compras estão pausadas no momento.",
    },
    FUNDED: {
      label: "Esgotado",
      description: "Todas as cotas deste projeto já foram adquiridas.",
    },
    FULLY_FUNDED: {
      label: "Esgotado",
      description: "Todas as cotas deste projeto já foram adquiridas.",
    },
    SOLD_OUT: {
      label: "Esgotado",
      description: "Todas as cotas deste projeto já foram adquiridas.",
    },
  };

  return options[value] || "--";
}

export function handleProjectStatus(value) {
  if (!value) return "--";

  value = value.toUpperCase();

  const options = {
    PLANNING: {
      label: "Em planejamento",
      description: "Obra/desenvolvimento em andamento.",
    },
    IN_CONSTRUCTION: {
      label: "Em construção",
      description: "Obra/desenvolvimento em andamento.",
    },
    COMPLETED: {
      label: "Concluído",
      description: "Desenvolvimento concluído. Escolhe-se o destino final.",
    },
    SOLD: {
      label: "Vendido",
      description: "Asset vendido. Estado final.",
    },
    RENTING: {
      label: "Alugando",
      description: "Asset gerando renda por aluguel. Estado final.",
    },
  };

  return options[value] || "--";
}
